module.exports = __webpack_public_path__ + "media/images/icons/energie-icons_info-weiss-6465745c010303bc21f667b0d4401b1a.svg";